import Autocomplete from '@mui/material/Autocomplete'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import TextField from '@mui/material/TextField'

import { ClickAwayListener, Slide } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getArticulos } from '../../actions/articulos'
import { getPedidoActivo } from '../../actions/pedidos'
import { setCustomer } from '../../actions/selectorCliente'
let optionsClientes = []

const SelectorClienteBuscador = () => {
  const dispatch = useDispatch()

  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
  const ecomClientesPermitidos = useSelector(state => state.auth.user.clientes_permitidos)
  const codigoClienteUsuario = useSelector(state => state.auth.user.id)
  const clienteSeleccionado = useSelector(state => state.selectorCliente.cliente_seleccionado)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const hash = useSelector(state => state.auth.hash)
  const [value, setValue] = useState(optionsClientes[0])
  const [anchorEl, setAnchorEl] = useState(null)
  const pedido = useSelector(state => state.pedidos.pedido)
  const invitado = useSelector(state => state.auth.invitados)

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined

  useEffect(() => {
    value?.value && sessionStorage.setItem('h_pers', value?.value)
    dispatch(setCustomer(value?.value))
    if (!invitado) {
      dispatch(
        getPedidoActivo(hash != null ? hash : '', 'S', id_pedido_seleccionado || pedido?.id_pedido),
      )
    }
    dispatch(getArticulos())
  }, [value])

  useEffect(() => {
    if (
      isAuthenticated &&
      ecomClientesPermitidos &&
      ecomClientesPermitidos.length > 0 &&
      optionsClientes.length === 0
    ) {
      ecomClientesPermitidos.forEach(cliente =>
        optionsClientes.push({
          key: cliente.id,
          label: cliente.codigo_cliente + ' - ' + cliente.nombre,
          value: cliente.id,
        }),
      )
      setValue(optionsClientes.filter(cli => cli?.key == sessionStorage.getItem('h_pers'))[0])
      if (
        (clienteSeleccionado === null || clienteSeleccionado === '') &&
        codigoClienteUsuario !== ''
      ) {
        dispatch(setCustomer(codigoClienteUsuario))
      }
    }
  }, [optionsClientes])

  return ecomClientesPermitidos !== undefined &&
    ecomClientesPermitidos.length > 0 &&
    (ecomClientesPermitidos.length > 1 ||
      (ecomClientesPermitidos.length === 1 &&
        ecomClientesPermitidos[0].id !== codigoClienteUsuario)) ? (
    <>
      <Button
        sx={{ color: 'black' }}
        onClick={handleClick}>
        {value?.label || 'Seleccionar cliente'}
      </Button>
      <Popper
        sx={{ zIndex: '9999999999' }}
        id={id}
        open={open}
        anchorEl={anchorEl}>
        <Slide in={open}>
          <Paper
            sx={{
              marginTop: '1rem',
              marginRight: '2rem',
              width: 500,
              backgroundColor: '#eee!important',
              borderBottomLeftRadius: '7px',
            }}>
            <ClickAwayListener onClickAway={handleClick}>
              <Autocomplete
                disablePortal
                id='combo-box-demo'
                options={optionsClientes}
                onChange={(event, newValue, reason) => {
                  setValue(newValue)
                  handleClick()
                }}
                disableClearable={true}
                sx={{}}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={'Selector de cliente'}
                  />
                )}
              />
            </ClickAwayListener>
          </Paper>
        </Slide>
      </Popper>
    </>
  ) : null
}

export default SelectorClienteBuscador
